import { Component, OnDestroy, Input } from '@angular/core';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-backdrop-bloqueio',
  templateUrl: './backdrop-bloqueio.component.html',
  styleUrls: ['./backdrop-bloqueio.component.scss']
})
export class BackdropBloqueioComponent implements OnDestroy {
  @Input() mostrarBloqueio = false;

  ngOnDestroy(): void {
    this.mostrarBloqueio = false;
  }
}
